import React from 'react';

type ActionStatusProps = {
  message?: string | null;
  error?: string | null;
  className?: string;
};

/** Success or error text shown next to admin save/submit actions. */
const ActionStatus: React.FC<ActionStatusProps> = ({ message, error, className = 'mt-2' }) => {
  if (error) {
    return (
      <p role="status" className={`${className} text-sm font-medium text-rose-950 bg-rose-200 border border-rose-400 rounded-lg px-3 py-2`}>
        {error}
      </p>
    );
  }
  if (!message) return null;
  return (
    <p role="status" className={`${className} text-sm font-medium text-amber-950 bg-amber-200 border border-amber-400 rounded-lg px-3 py-2`}>
      {message}
    </p>
  );
};

export default ActionStatus;
